import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import { buyNFT } from "../utils/callHelpers";
import { getBuyNFTContract } from "../utils/contractHelpers";
import useWeb3 from "../hooks/useWeb3";

export const useBuyNFT = () => {
  const { account } = useWeb3React();

  const web3 = useWeb3();
  const contract = getBuyNFTContract(web3);

  const handleBuy = useCallback(
    async (nftType, quantity) => {
      const txHash = await buyNFT(contract, nftType, quantity, account);
      return txHash;
    },
    [account, contract]
  );

  return { onBuyNFT: handleBuy };
};
